import React, { useEffect } from "react"
import { Box, Progress } from "@carrotfertility/carotene-core"
import useGetBlueshiftUuid from "#/services/user/hooks/useGetBlueshiftUuid"
import { ErrorPage } from "#/components/views/app/ErrorPage"

const EMAIL_PREFERENCES_PAGE_URL = "https://go.get-carrot.com/customer/email_preferences"

function buildEmailPreferencesUrl(uuid: string): string {
  const url = new URL(EMAIL_PREFERENCES_PAGE_URL)
  url.searchParams.set("uid", uuid)
  return url.href
}

export function CommunicationPreferencesRedirect(): JSX.Element {
  const { data: uuid, isLoading } = useGetBlueshiftUuid()

  useEffect(() => {
    if (uuid) {
      window.location.href = buildEmailPreferencesUrl(uuid)
    }
  }, [uuid])

  if (!isLoading && !uuid) {
    return <ErrorPage />
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
      <Progress />
    </Box>
  )
}
